import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SfaQualificationCriteriaFieldValuesHdrContainerModel } from "../../../../../models/aggregates/sfa/SfaQualificationCriteriaFieldValuesHdrContainer.model";
import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { Core2Config } from "../shared/core2Config";

@Injectable({
	providedIn: "root",
})
export class SfaQualificationCriteriaFieldValuesHdrService extends BaseApiTemplateService<SfaQualificationCriteriaFieldValuesHdrContainerModel> {
	readonly url =
		Core2Config.TENANT_DOMAIN_URL_PREFIX +
		Core2Config.SFA_MODULE_PREFIX +
		"qualification-criteria-field-values";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_URL +
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"qualification-criteria-field-values";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"qualification-criteria-field-values";
		this.httpClient = http;
	}
}
